/**
 * Component which is used to display the icons.
 */
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseControl } from '../../constants/base-control-constants';
import { ICON_CONFIG } from '../../constants//ui-contants';
import { TooltipDirective } from '@zen/ui/directives/tooltip.directive';

@Component({
  selector: 'zen-icon',
  standalone: true,
  imports: [CommonModule, TooltipDirective],
  templateUrl: './zen-icon.component.html',
  styleUrl: './zen-icon.component.scss',
})
export class ZenIconComponent extends BaseControl {
  /**
   * Varibale which is used to store the title of the icon.
   * @type { string }
   */
  @Input() toolTipText!: string | number;
  /**
   * Variable whcih is used to access the zen icon constant values
   */
  iconConfig = ICON_CONFIG;
  /**
   * Variable which is used to store the icon name.
   * @type {string}.
   */
  @Input() iconName !: string;
}
